import { Collapse, Text } from "@marketplace/ui";
import clsx from "clsx";
import { useAtomValue } from "jotai";
import React from "react";

import { isPromoAvailableAtom } from "../../atoms/product-form-atom";
import { PromoPill } from "../promo-pill";

type ProductFormSectionCardProps = {
  id: string;
  title: string | React.ReactNode;
  children: React.ReactNode;
  titleRightSection?: React.ReactNode;
  isCollapsible?: boolean;
  isOpen?: boolean;
  showPromoPill?: boolean;
};

export const ProductFormSectionCard: React.FC<ProductFormSectionCardProps> = ({
  id,
  title,
  children,
  titleRightSection,
  isCollapsible = false,
  isOpen = true,
  showPromoPill = false
}) => {
  const isPromoAvailable = useAtomValue(isPromoAvailableAtom);
  return (
    <div
      id={id}
      className="bg-brand-white rounded-lg border border-solid border-mischka-400 scroll-mt-6"
    >
      <div
        className={clsx(
          "p-6 ",
          isOpen && "border-solid border-0 border-b border-b-mischka-400"
        )}
      >
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-x-2">
            <Text
              type="heading"
              size="l"
              weight="bold"
              className="text-fjord-grey-400"
            >
              {title}
            </Text>
            {showPromoPill && isPromoAvailable && <PromoPill />}
          </div>
          {titleRightSection}
        </div>
      </div>
      {isCollapsible ? (
        <Collapse in={isOpen}>
          <div className="p-6">{children}</div>
        </Collapse>
      ) : (
        <div className="p-6">{children}</div>
      )}
    </div>
  );
};
